var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgShare = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.89171 9.00671L10.445 11.66M10.4384 4.34004L5.89171 6.99337M14.165 3.33337C14.165 4.43794 13.2696 5.33337 12.165 5.33337C11.0605 5.33337 10.165 4.43794 10.165 3.33337C10.165 2.2288 11.0605 1.33337 12.165 1.33337C13.2696 1.33337 14.165 2.2288 14.165 3.33337ZM6.16504 8.00004C6.16504 9.10461 5.26961 10 4.16504 10C3.06047 10 2.16504 9.10461 2.16504 8.00004C2.16504 6.89547 3.06047 6.00004 4.16504 6.00004C5.26961 6.00004 6.16504 6.89547 6.16504 8.00004ZM14.165 12.6667C14.165 13.7713 13.2696 14.6667 12.165 14.6667C11.0605 14.6667 10.165 13.7713 10.165 12.6667C10.165 11.5621 11.0605 10.6667 12.165 10.6667C13.2696 10.6667 14.165 11.5621 14.165 12.6667Z",
    stroke: "#D1D1D1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgShare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/share.034fc724.svg";
export { ForwardRef as ReactComponent };